import InnerHTMLContainer from '../../molecules/InnerHTMLContainer';
import { Typography } from '../../molecules/Typography';

interface RadioProps {
  id: string;
  label: string;
  value: string;
  checked: boolean;
  checkedColorType?: 'default' | 'success' | 'error' | 'correct';
  labelType?: 'html' | 'text';
  disabled?: boolean;
  onChange: () => void;
}

const Radio = ({
  id,
  label,
  value,
  checked,
  checkedColorType = 'default',
  disabled = false,
  onChange,
  labelType = 'html',
}: RadioProps) => {
  const checkedColorStyle = {
    default:
      'bg-mono-color-white border-mono-color-dark checked:border-color-brand-primary checked:bg-brand-color-primary-lighter checked:after:border-color-brand-primary checked:after:bg-color-brand-primary checked:focus:border-color-brand-primary',
    success:
      'border-feedback-color-success-darkest checked:border-feedback-color-success-darkest checked:bg-feedback-color-success-lightest checked:after:border-feedback-color-success-darkest checked:after:bg-feedback-color-success-darkest checked:focus:border-feedback-color-success-darkest',
    error:
      'border-feedback-color-error-darkest checked:border-feedback-color-error-darkest checked:bg-feedback-color-error-lightest checked:after:border-feedback-color-error-darkest checked:after:bg-feedback-color-error-darkest checked:focus:border-feedback-color-error-darkest',
    correct: 'bg-mono-color-light border-mono-color-dark',
  };

  const isImage = label.includes('<img')

  return (
    <div className='flex items-center gap-md'>
      <input
        id={`radio_${id}`}
        type='radio'
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={`${checkedColorStyle[checkedColorType]} relative h-5 w-5 appearance-none rounded-circular border-thin text-mono-color-white before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-circular before:opacity-0 before:content-[''] after:absolute after:z-[0] after:block after:h-4 after:w-4 after:rounded-circular after:content-[''] checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-circular checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer hover:before:opacity-[0.04] focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] checked:focus:before:scale-100`}
      />
      <label
        onClick={disabled ? undefined : onChange}
        className='hover:cursor-pointer'
      >
        {labelType === 'html' ? (
          <InnerHTMLContainer
            data={`${label}`}
            className={isImage ? '[&>p]:flex [&>p]:flex-row [&>p]:items-center [&>p]:gap-2 [&>p__img]:bg-[#fff] text-mono-color-darkest' : 'text-mono-color-darkest'}
            type='courseProgram'
          />
        ) : (
          <Typography className={'text-mono-color-darkest'}>
            {label}
          </Typography>
        )}
      </label>
    </div>
  );
};

export default Radio;
